import { useState } from 'react';
import { PAUZE_KEUZES_MS, PAUZE_MS_STANDAARD } from '@tolk/shared';
import { ApiFout, wijzigKamer } from '../lib/api';

/**
 * De pauze na het laatste woord instellen, TIJDENS het gesprek.
 *
 * Alleen voor de maker van het gesprek (de beheerder), net als de Meet-link en
 * het budget: het gaat via de beheerroute. De nieuwe stand komt over de
 * kamerverbinding bij allebei de stiltemeters aan, zonder herladen. Zie
 * shared/src/pauze.ts voor het waarom.
 *
 * Nederlands en niet in zestien talen: alleen de beheerder ziet dit blok.
 */
export default function PauzeInstellen({
  kamerId,
  pauzeMs,
}: {
  kamerId: string;
  pauzeMs: number;
}) {
  const [bezig, setBezig] = useState(false);
  const [fout, setFout] = useState<string | null>(null);

  async function bewaar(waarde: number): Promise<void> {
    setBezig(true);
    setFout(null);
    try {
      await wijzigKamer(kamerId, { pauzeMs: waarde });
    } catch (error) {
      setFout(error instanceof ApiFout ? error.message : 'Bewaren lukte niet.');
    } finally {
      setBezig(false);
    }
  }

  return (
    <section className="mt-1.5 border-t border-slate-150 pt-2 space-y-1.5">
      <label
        htmlFor="pauze-na-laatste-woord"
        className="block text-[11px] font-bold uppercase tracking-wide text-slate-450"
      >
        Pauze na laatste woord
      </label>
      <select
        id="pauze-na-laatste-woord"
        value={pauzeMs}
        disabled={bezig}
        onChange={(e) => void bewaar(Number(e.target.value))}
        className="w-full p-1.5 bg-slate-50 border-2 border-slate-250 rounded-lg text-[11px]
                   text-slate-800 cursor-pointer focus:outline-none focus:border-gio-blue
                   transition-colors duration-155 disabled:opacity-50"
      >
        {PAUZE_KEUZES_MS.map((ms) => (
          <option key={ms} value={ms}>
            {(ms / 1000).toLocaleString('nl-NL', { minimumFractionDigits: 1 })} s
            {ms === PAUZE_MS_STANDAARD ? ' (standaard)' : ''}
          </option>
        ))}
      </select>
      <p className="text-[11px] text-slate-450 leading-relaxed">
        Korter is sneller. Te kort knipt je zin af als je even nadenkt. Geldt voor jullie allebei.
      </p>
      {fout !== null && <p className="text-[11px] text-gio-danger">{fout}</p>}
    </section>
  );
}
